import React from "react";
import { Translation } from "react-i18next";
import "../Pages/card.scss";

export const TagButton = ({ name, handleSetTag, tagactive }) => {
  return (
    <Translation>
      {(t) => (
        <div>
          <button
            className="card__btn"
            id={`tag ${tagactive ? "active" : null}`}
            onClick={() => handleSetTag(name)}
          >
            {t(["portfolio.button-5"])}
          </button>
        </div>
      )}
    </Translation>
  );
};

export const TagButtonAll = ({ name, handleSetTag, tagactive }) => {
  return (
    <Translation>
      {(t) => (
        <div>
          <button
            className="btn-outline-light-all py-3 px-5 mt-4 mb-4 rounded-0"
            id={`tag ${tagactive ? "active" : null}`}
            onClick={() => handleSetTag(name)}
          >
            {t(["portfolio.button-4"])}
          </button>
        </div>
      )}
    </Translation>
  );
};
